import React, { ReactElement } from 'react';
import { motion } from 'framer-motion';

import COLORS from '~/constants/colors';
import { FONT_WEIGHTS } from '~/constants/typography';

import { RendererProps } from '../../models';
import { getPx } from '../../helpers';

function Feedback({ entity }: RendererProps): ReactElement {
  const pos = entity.getPos();
  const stat = entity.stat > 999 ? 'MAX' : entity.stat;

  // Styling
  const feedbackStyle = {
    position: 'absolute' as const,
    width: getPx(entity.dims.w),
    height: getPx(entity.dims.h),
    left: getPx(pos.x - entity.dims.w / 2),
    top: getPx(pos.y - entity.dims.h / 2),
    textAlign: 'center' as const,
    textShadow: `0 0 ${getPx(entity.dims.w / 18)} ${COLORS.black25}`,
    fontWeight: FONT_WEIGHTS.heavy,
    opacity: 0,
    zIndex: 4,
  };
  const statStyling = {
    color: entity.statColor,
    fontSize: getPx(entity.dims.h / 1.5),
  };
  const ratingStyling = {
    color: entity.ratingColor,
    fontSize: getPx(entity.dims.h / 3),
  };

  // Animation
  const variants = {
    reset: {
      opacity: 1,
    },
    show: {
      opacity: [0, 1, 0],
      transition: {
        duration: 0.45,
        ease: ['easeOut', 'linear'],
        times: [0, 0.33, 1],
      },
    },
  };

  return (
    <motion.div
      style={feedbackStyle}
      animate={entity.animate}
      variants={variants}
    >
      <div style={statStyling}>{stat}</div>
      <div style={ratingStyling}>{entity.rating}</div>
    </motion.div>
  );
}

export default Feedback;
